import React, { useState, useEffect } from 'react';
import { Grid, Typography, Box, Tab } from '@material-ui/core';
import PropTypes from 'prop-types';
import TabContext from '@material-ui/lab/TabContext';
import TabList from '@material-ui/lab/TabList';
import useStyles from '../../Main.style';
import useCalendarEvents from '../../../../hooks/useCalendarEvents';
import useImport from '../../../../hooks/useImport'; /* eslint-disable-next-line */
import FinancialAnalysis from './../FinancialAnalysis/FinancialAnalysis'; /* eslint-disable-next-line */
import EmployeePerformance from './../EmployeePerformance/EmployeePerformance'; /* eslint-disable-next-line */
import EmployeeScoreTable from './../EmployeeScoreTable/EmployeeScoreTable';

const EmployeeAnalysisTab = () => {
  let calendarEventsData = {};

  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box mx={2}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
  TabPanel.propTypes = {
    /* eslint-disable-next-line */
    /* eslint-disable-next-line */ children: PropTypes.node /* eslint-disable-next-line */,
    index: PropTypes.any.isRequired /* eslint-disable-next-line */,
    value: PropTypes.any.isRequired,
  };
  const [subTabValue, setSubTabValue] = React.useState(0);
  const [allFinancialCompensationData, setAllFinancialCompensationData] = useState([]);

  const handleSubTabChange = (event, newValue) => {
    setSubTabValue(newValue);
  };

  const { getAllFinancialCompensationData } = useImport();
  const { getCalendarEventsForWeek } = useCalendarEvents();

  const loadAllFinancialCompensationData = async () => {
    const result = await getAllFinancialCompensationData();
    if (result) {
      setAllFinancialCompensationData(result?.usersResult || []);
    }
  };

  const loadGetCalendarEventsForWeek = async () => {
    if (Object.keys(calendarEventsData).length === 0) {
      calendarEventsData = await getCalendarEventsForWeek();
    }
  };

  useEffect(() => {
    loadAllFinancialCompensationData(); /* eslint-disable-next-line */
  }, []);
  /* eslint-disable-next-line */
  useEffect(() => {
    loadGetCalendarEventsForWeek(); /* eslint-disable-next-line */
  }, []);

  const classes = useStyles();
  return (
    <>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Box m={1} />
        </Grid>
        <Box sx={{ width: '100%', typography: 'body1' }} className={classes.EmployeeAnalysisTabs}>
          <TabContext value={subTabValue}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }} pt={1}>
              <TabList onChange={handleSubTabChange} aria-label="">
                <Tab label="Financial Analysis " />
                <Tab label="Employee Performance" />
                <Tab label="Employee Score" />
              </TabList>
            </Box>
            <Box>
              <Grid
                item
                xs={12}
                className={classes.innercontent}
                style={{ borderTopLeftRadius: 'inherit' }}
              >
                <TabPanel value={subTabValue} index={0}>
                  <EmployeePerformance
                    allFinancialCompensationData={allFinancialCompensationData}
                  />
                </TabPanel>
                <TabPanel value={subTabValue} index={1}>
                  <FinancialAnalysis />
                </TabPanel>
                <TabPanel value={subTabValue} index={2}>
                  <EmployeeScoreTable />
                </TabPanel>
              </Grid>
            </Box>
          </TabContext>
        </Box>
      </Grid>
    </>
  );
};

export default EmployeeAnalysisTab;
